import type { FC } from 'react'
import styled from '@emotion/styled'
import { m } from 'framer-motion'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import CreateSingleViewOfTheCustomerImage from './CreateSingleViewOfTheCustomerImage'

const copy = {
  heading: `Create a complete view of the customer`,
  description: `Collect data the right way and align across teams. Understand your customer journey across all platforms and channels and optimize your offers by predicting the likelihood someone will buy.`,
}

const CreateSingleViewOfTheCustomer: FC = () => {
  return (
    <SectionBase variant="2Col" reverse={true}>
      <Section.Copy alignSelf="center">
        <CopyTextBase>
          <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge">
            {copy.description}
          </CopyText.Description>
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <Contents>
          <ImageWrapper
            initial={{ opacity: 0 }}
            whileInView={{
              opacity: 1,
              transition: {
                duration: 0.4,
                delay: 0.1,
              },
            }}
            viewport={{ once: true }}
          >
            <CreateSingleViewOfTheCustomerImage />
          </ImageWrapper>
        </Contents>
      </Section.Contents>
    </SectionBase>
  )
}

export default CreateSingleViewOfTheCustomer

const Contents = styled.div`
  position: relative;
  height: 100%;
`

const ImageWrapper = styled(m.div)``
